import { Injectable, computed, inject, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { NessusScan, NessusScanHistory } from '../models';
import { AdminScanService } from '../services';

@Injectable()
export class NessusScanStore {
  private readonly adminScanService = inject(AdminScanService);

  readonly scans = signal<NessusScan[]>([]);
  readonly history = signal<NessusScanHistory[]>([]);

  readonly isScansLoading = signal(false);
  readonly isHistoryLoading = signal(false);

  loadScans() {
    this.isScansLoading.set(true);
    return this.adminScanService.getNessusScans().pipe(finalize(() => this.isScansLoading.set(false)));
  }

  loadHistory(scanId: string) {
    this.isHistoryLoading.set(true);
    return this.adminScanService.getNessusScanHistory(scanId).pipe(finalize(() => this.isHistoryLoading.set(false)));
  }

  setScans(scans: NessusScan[]) {
    this.scans.set(scans);
  }

  setHistory(history: NessusScanHistory[]) {
    this.history.set(history);
  }

  clearHistory() {
    this.history.set([]);
  }

  clear() {
    this.scans.set([]);
    this.history.set([]);
  }
}
